:host {
    display: inline-flex;
    align-items: center;
    appearance: link;
    width: 1.2em;
    cursor: pointer;
    position: relative;
}

svg {
    width: 100%;
    height: 100%;
    fill: currentColor;
}